import * as loadImage from 'blueimp-load-image'

const TEMPORARY_UPLOAD_API = '/api/image/tmpSend'
// 初期設定
const defaultConfig = {
  maxWidth: 2000, // 画像の最大幅
  processingCapacity: 2 * 1024 * 1024 // 加工後の最大ファイルサイズ(とりあえず2MB以上は圧縮)
}

/**
 * 画像をblobに変換してアップロードするためのクラス
 * @param {file} - アップロード対象のファイル
 * @param {config} - アップロード関連の設定
 */
export default class UploadImageByBlob {
  constructor(file, config = {}) {
    if (!file) throw new Error('ファイルがありません')

    this.file = file
    this.type = file.type
    this.canvas = null
    this.originalBlob = null
    this.uploadBlob = null
    this.maxWidth = config.maxWidth || config.maxWidth
    this.processingCapacity =
      config.processingCapacity || defaultConfig.processingCapacity
  }

  /**
   * exif情報からorientationを取得
   * @param {File} file - 対象ファイル
   * @return {Promise} orientation情報の数値
   */
  _getOrientation(file) {
    return new Promise(resolve => {
      loadImage.parseMetaData(file, data => {
        if (data.exif) {
          resolve(data.exif[0x0112])
        } else {
          resolve(0)
        }
      })
    })
  }

  /**
   * ファイルからHTMLCanvasElementを取得
   * @param {Number} orientation - exifのorientation情報
   * @return Promise(HTMLCanvasElement)
   */
  _getCanvasImage() {
    return this._getOrientation(this.file).then(orientation => {
      return new Promise((resolve, reject) => {
        // ファイル形式がjpg, png以外の場合はreject
        if (!/image\/(jpe?g|png)/.test(this.type)) {
          reject('有効なファイル形式ではありません')
        }
        loadImage(
          this.file,
          canvas => {
            resolve(canvas)
          },
          {
            canvas: true,
            maxWidth: this.maxWidth,
            meta: false,
            orientation: Number(orientation)
          }
        )
      })
    })
  }

  /**
   * base64からblobへ変換する
   * @param {String} base64
   * @param {String} type - mimeType
   * @return Promise(Blob)
   */
  base64ToBlob(base64, type) {
    const base64Data = base64.split(',')[1] // Data URLからBase64のデータ部分のみを取得
    const data = window.atob(base64Data) // base64形式の文字列をデコード
    const buff = new ArrayBuffer(data.length)
    let arr = new Uint8Array(buff)
    // blobの生成
    for (let i = 0, dataLen = data.length; i < dataLen; i++) {
      arr[i] = data.charCodeAt(i)
    }
    const blob = new Blob([arr], { type })
    return blob
  }

  /**
   * canvasをblobに変換する
   * @param {Element} canvas
   * @param {String} type - ファイルのmimeType
   */
  createUploadFileBlob() {
    return this._getCanvasImage().then(canvas => {
      return new Promise(resolve => {
        this.originalBlob = this.base64ToBlob(
          canvas.toDataURL(this.type),
          this.type
        )

        this.uploadBlob = this.originalBlob
        // サイズが大きい場合は圧縮する
        if (this.processingCapacity < this.uploadBlob.size) {
          const compressionRatio =
            this.processingCapacity / this.uploadBlob.size
          const compressedBinary = canvas.toDataURL(this.type, compressionRatio)
          this.uplaodBlob = this.base64ToBlob(compressedBinary, this.type)
        }
        resolve()
      })
    })
  }

  upload() {
    return this.createUploadFileBlob().then(() => {
      const params = new FormData()
      params.append('file', this.uploadBlob)
      return axios
        .post(TEMPORARY_UPLOAD_API, params, {
          'content-type': 'multipart/form-data'
        })
        .then(res => {
          return Promise.resolve(res)
        })
        .catch(error => {
          return Promise.reject('アップロードに失敗しました。')
        })
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/UploadImageByBlob.js